import {
    SET_PRODUCTS,
    SET_PRODUCT_BY_MODE,
    SET_DETAIL_PRODUCT,
    SET_PRODUCTS_CLIENT,
    SET_DIALOG_ACTIVE,
    SET_LIST_COUNTRY
} from "@/views/products/store/types/types.js";


const mutations = {
    [SET_PRODUCTS]: (state, payload) => state.products = payload,
    [SET_PRODUCT_BY_MODE]: (state, payload) => state.product_by_mode = payload,
    [SET_DETAIL_PRODUCT]: (state, detailproduct) => state.detailproduct = detailproduct,
    [SET_PRODUCTS_CLIENT]: (state, productsClient) => state.productsClient = productsClient,
    [SET_DIALOG_ACTIVE]: (state, { status, index }) => state.products[index]['activeDialogProduct'] = status,
    [SET_LIST_COUNTRY]: (state, payload) => state.countryCode = payload
    
};

export default mutations